import { useNabooContentStore } from '@/presentation/stores/content/nabooContent'
import { storeToRefs } from 'pinia'
import { onMounted } from 'vue'
import { useToast } from 'primevue/usetoast'
import CNabooContentDiagnosticDialog from '@/presentation/components/content/CNabooContentDiagnosticDialog.vue'
import { useDialog } from 'primevue/usedialog'
import type { NabooContentDiagnostic } from '@/core/domain/nabooContent/NabooContent.ts'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'
import type { QuizVersion } from '@/core/domain/quiz/QuizVersion.ts'

export function useNabooContent() {
  // SERVICES
  const toast = useToast()
  const dialog = useDialog()
  // STORES
  const { fetchNabooContent } = useNabooContentStore()
  const { listAxis } = storeToRefs(useNabooContentStore())

  onMounted(async () => {
    try {
      await fetchNabooContent()
    } catch (error) {
      if (error instanceof Error) {
        toast.add({ severity: 'error', summary: 'Erreur', detail: error.message })
      } else {
        toast.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Une erreur est survenue, merci de contacter le support'
        })
      }
    }
  })

  const openDiagnosticDialog = (courseId: number, start: boolean = true) => {
    const axis = listAxis.value.find((axis) =>
      axis.learningCourses.some((course) => course.id === courseId)
    )
    if (!axis) return
    const course = axis.learningCourses.find((course) => course.id === courseId)
    const input = start ? course?.diagnosticStart : course?.diagnosticEnd

    if (input) {
      dialog.open(CNabooContentDiagnosticDialog, {
        props: {
          header: `Parcours - ${input.learningCourseTitle}`,
          modal: true,
          dismissableMask: true,
          draggable: false,
          style: 'width: 50vw',
          breakpoints: {
            '960px': '50vw',
            '640px': '95vw'
          }
        },
        data: {
          diagnostic: input,
          subtitle: input.title
        }
      })
    }
  }

  /**
   *
   * @param title
   * @param blocks Pair "title"/QuizVersion
   */
  const openQuizVersionDialog = (title: string, blocks: Record<string, QuizVersion>) => {
    dialog.open(CNabooContentDiagnosticDialog, {
      props: {
        header: `${title}`,
        modal: true,
        dismissableMask: true,
        draggable: false,
        style: 'width: 50vw',
        breakpoints: {
          '960px': '50vw',
          '640px': '95vw'
        }
      },
      data: {
        blocks: blocks,
        title: title
      }
    })
  }

  const openModuleContent = async (moduleId: number, courseId: number) => {
    window.open(`/contenus-naboo/parcours/${courseId}/modules/${moduleId}`, '_blank')
  }

  return {
    openDiagnosticDialog,
    openQuizVersionDialog,
    openModuleContent
  }
}
